<div class="app-header header sticky">
  <div class="container-fluid main-container">
    <div class="d-flex flex-block" [ngClass]="{ 'align-items-center': !hideUserAction }">
      <a class="headerMobileToggler" (click)="toggleSidebar()" aria-label="Open folder">
        <img src="../../../../assets/images/icon/Ic_Menu.svg" alt="Menu icon" />
      </a>

      <!-- sidebar-toggle-->
      @if (hideUserAction) {
        <a class="pointer back" (click)="back()" aria-label="Open folder"
          ><img src="../../../../assets/icons/left_arrow.svg" width="20px" alt="Back icon"
        /></a>
      }

      <div class="pageTitle">
        <h1 class="page-title">
          {{ pageInfo?.title || '' }}

          <span
            *ngIf="pageInfo?.title === 'Dataspaces'"
            class="infoIcn"
            placement="right"
            triggers="mouseenter:mouseleave"
            popoverClass="customPopover green"
            [ngbPopover]="popContent"
          >
            <img
              src="../../../../assets/icons/data-connect.svg"
              width="16px"
              alt="Data connect icon"
            />
          </span>

          <ng-template #popContent>
            <strong class="fs-13"
              >Dataspaces help you organize content and ensure the right information is available to
              the right users.</strong
            >
            <p class="fs-13 mb-0 mt-2">
              Each Dataspace contains documents that serve as a knowledge base. Control which users
              can access specific Dataspaces to manage information visibility across your
              organization.
            </p>
          </ng-template>
        </h1>
        @if (description) {
          <p
            class="page-subtitle mb-0"
            [ngbPopover]="description.length > 100 ? description : null"
            placement="bottom"
            popoverClass="customPopover"
            triggers="mouseenter:mouseleave"
          >
            {{ description }}
          </p>
        }
      </div>
      <div class="ms-auto rolehead d-flex align-items-center">
        @if (isAgentChat && chatId) {
          <app-agent-action [chatId]="chatId"></app-agent-action>
        }
        @if (!isAgentChat) {
          <app-header-right [role]="userInfo?.role"></app-header-right>
        }
      </div>
    </div>
  </div>
</div>
